import { useParams } from '@tanstack/react-router'
import { EventCard, mapInvestorFeedItems } from '@workspace/seedforge-ui/feed'
import { Inbox, Loader2 } from 'lucide-react'
import { InvestorLayout } from '../../components/investor-layout'
import { useInvestorFeedQuery } from '../../hooks/api'
import { useBasePath } from '../../hooks/use-base-path'

export function InvestorFeedPage() {
  const { id: investorId } = useParams({ strict: false }) as { id: string }
  const basePath = useBasePath()
  const { data, isLoading, error } = useInvestorFeedQuery(investorId)

  if (isLoading) {
    return (
      <InvestorLayout activeNav="Feed">
        <div className="flex h-64 items-center justify-center">
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        </div>
      </InvestorLayout>
    )
  }

  if (error || !data?.data) {
    return (
      <InvestorLayout activeNav="Feed">
        <div className="flex h-64 items-center justify-center text-muted-foreground">
          Failed to load feed
        </div>
      </InvestorLayout>
    )
  }

  const timeline = mapInvestorFeedItems(data.data, basePath)

  return (
    <InvestorLayout activeNav="Feed">
      {timeline.length === 0 ? (
        <div className="flex min-h-[calc(100vh-6rem)] flex-col items-center justify-center text-center">
          <div className="flex size-16 items-center justify-center rounded-2xl bg-muted/50">
            <Inbox className="size-7 text-muted-foreground/40" />
          </div>
          <h2 className="mt-5 text-lg font-semibold text-foreground">No pitches yet</h2>
          <p className="mt-1.5 max-w-xs text-sm text-muted-foreground/60">
            Share your SeedForge link to start receiving pitches from founders
          </p>
        </div>
      ) : (
        <div className="mx-auto max-w-6xl py-2">
          <div>
            <h1 className="text-2xl font-semibold tracking-tight text-foreground">Feed</h1>
            <p className="mt-1 text-sm text-muted-foreground">Pitches received through your link</p>
          </div>
          <div className="mt-8">
            {timeline.map((event) => (
              <EventCard key={event.id} event={event} />
            ))}
          </div>
        </div>
      )}
    </InvestorLayout>
  )
}
